<template>
  <div class="dialogs">
    <DialogOversold />
    <DialogOrderError />
    <DialogAppUpdate />
    <DialogPlacingOrder />
    <DialogCartDatePicker />
    <DialogUpdateTimezone />
    <OrderPrepDatePicker />
  </div>
</template>

<script>
import DialogOversold from '@/components/DialogOversold'
import DialogOrderError from '@/components/DialogOrderError'
import DialogAppUpdate from '@/components/DialogAppUpdate'
import DialogPlacingOrder from '@/components/DialogPlacingOrder'
import DialogCartDatePicker from '@/components/DialogCartDatePicker'
import OrderPrepDatePicker from '@/components/OrderPrepDatePicker'
import DialogUpdateTimezone from '@/components/DialogUpdateTimezone'

export default {
  name: 'Dialogs',
  components: {
    DialogOversold,
    DialogOrderError,
    DialogAppUpdate,
    DialogPlacingOrder,
    DialogCartDatePicker,
    DialogUpdateTimezone,
    OrderPrepDatePicker,
  },
  data() {
    return {}
  },
}
</script>
